"use client";

export default function Tools() {
  const tools = [
    {
      title: "Get AI to Reply to Your Emails",
      icon: "/images/ad1.svg",   
    },
    {
      title: "Get an Assistant for Tasks",
      icon: "/images/ad2.svg",   
    },
    {
      title: "Summarize Anything on Web",
      icon: "/images/ad3.svg",   
    },
    {
      title: "Uncover Insights from Docs",
      icon: "/images/ad4.svg",   
    },
    {
      title: "Create Content from Long Videos",
      icon: "/images/ad5.svg",   
    },
    {
      title: "Supercharge your Productivity",
      icon: "/images/ad6.svg",   
    },
    {
      title: "Create PPTs in Minutes",
      icon: "/images/ad7.svg",   
    },
    {
      title: "Become an Excel Pro",
      icon: "/images/ad8.svg",   
    },
    {
      title: "Create Websites in Seconds",
      icon: "/images/ad9.svg",   
    },
  ];

  return (
    <section className="w-full py-6 md:py-12">
      <div className="w-[90%] md:w-[80%] mx-auto">
        {/* Header Section */}
        <div className="mb-8 text-left">
          <p className="text-[#0A0A0A] text-sm md:text-base font-normal uppercase mb-2">
            TOOLS
          </p>
          <h2 className="text-[#002726] text-[28px] md:text-[32px] font-medium mb-3 w-full md:w-[80%]">
            Learn 15+ Essential AI Tools
          </h2>
        </div>

        {/* Tools Grid - 3 columns for both desktop and mobile */}
        <div className="grid grid-cols-3 gap-4 md:gap-6">
          {tools.map((tool, index) => (
            <div
              key={index}
              className="rounded-xl p-4 border border-[#818490] text-left"
              style={{ backgroundColor: "#FFFAF1" }}
            >
              {/* SVG Icon Placeholder */}
              {tool.icon ? (
                <div className="mb-3 w-8 h-8">
                  <img
                    src={tool.icon}
                    alt={tool.title}
                    className="w-8 h-8 object-contain"
                  />
                </div>
              ) : (
                <div className="mb-3 w-8 h-8">
                  <svg
                    className="w-8 h-8 text-[#0A0A0A]"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    {/* Empty placeholder - user will replace */}
                  </svg>
                </div>
              )}
              <h3 className="text-[#002726] text-sm md:text-base font-normal">
                {tool.title}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
